import Profiles from './Profiles/Profiles';

class Resellers {
    constructor(settings) {
        this.settings = settings;

        this.profiles = new Profiles(this.settings);
    }
}

export default Resellers;
